import { simpleUserFragment } from './fragmentsUser';

import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const userCreateMutationAtom = createMutationAtomFactory(
  'admin.userCreate',
  (params: {
    firstName: string;
    lastName: string;
    email: string;
    phoneNumber?: string;
    timezone: string;
    idpId?: string;
    organizationId?: string;
  }) => ({
    coreUserCreate: {
      __args: {
        input: {
          firstName: params.firstName,
          lastName: params.lastName,
          email: params.email,
          phoneNumber: params.phoneNumber,
          timezone: params.timezone,
          idpId: params.idpId,
          organizationId: params.organizationId,
        },
      },
      ...simpleUserFragment,
    },
  }),
);
